<template>
  <el-dialog
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    :before-close="() => showDialog = false"
    :fullscreen="isFullscreen"
    :show-close="false"
    width="1350px">
    <div slot="title" class="dialog-title">
      <span>历史报价轮次</span>
      <div class="titleButtonContainer">
        <vxe-button type="text" @click="isFullscreen = !isFullscreen">
          <img :src="require('@/assets/table/ic_shouqi.svg')" v-if="!isFullscreen">
          <img :src="require('@/assets/table/ic_zhankai.svg')" v-else>
        </vxe-button>
        <vxe-button type="text" icon="vxe-icon-close" @click="showDialog = false"></vxe-button>
      </div>
    </div>
    <template v-if="roundsList.length">
      <el-tabs v-model="active" @tab-click="handleClick">
        <el-tab-pane v-for="(rounds, index) in roundsList" :key="index" :label="rounds.label" :name="rounds.value"></el-tab-pane>
      </el-tabs>
      <div v-if="currentQuotation.quotationDetail.rollbackReason" class="warning-tip">
        <i class="el-icon-warning"></i>
        回退原因：{{ currentQuotation.quotationDetail.rollbackReason }}
      </div>
      <div v-if="currentQuotation.quotationDetail.rejectTypeDesc" class="warning-tip">
        <i class="el-icon-warning"></i>
        拒单原因：{{ currentQuotation.quotationDetail.rejectTypeDesc }}
      </div>
      <div v-if="currentQuotation.quotationDetail.negotiatingType === 'UPDATE'" class="warning-tip">
        <i class="el-icon-warning"></i>
        修改报价：与供应商协商一致后，修改报价，本轮报价作废。
      </div>
      <div style="position: relative;">
        <base-info :outsidePlugin="false" :info="currentQuotation.quotationDetail" :haveHistory="false" />
      </div>
      <QuotationTableMaintenance v-if="currentQuotation.quotationDetail.businessType === 'MAINTAIN'" :quotationDetail="currentQuotation.quotationDetail" />
      <SparepartTable v-if="currentQuotation.quotationDetail.businessType === 'MAINTAIN'" :list="currentQuotation.quotationDetail.itemList" />
      <QuotationTableNonMaintenance v-if="currentQuotation.quotationDetail.businessType === 'SPARE_PART'" :info="currentQuotation.quotationDetail" />
      <span slot="footer" class="dialog-footer" style="text-align: right;">
        <el-button @click="() => showDialog = false">关 闭</el-button>
      </span>
    </template>
    <el-empty v-else :image="emptyIcon" description="暂无历史报价"></el-empty>
  </el-dialog>
</template>
<script>
import QuotationTableMaintenance from './quotationTableMaintenance.vue';
import QuotationTableNonMaintenance from './quotationTableNonMaintenance.vue';
import SparepartTable from './sparepartTable.vue';
import { historyQuotePriceList } from '@/api/RFQ';
export default {
  components: {
    BaseInfo: () => import('./baseInfo.vue'),
    QuotationTableMaintenance,
    QuotationTableNonMaintenance,
    SparepartTable,
  },
  data () {
    return {
      isFullscreen: false,
      emptyIcon: require('@/assets/imgs/default.svg'), // eslint-disable-line no-undef
      inquirePriceId: '', // 询价单id
      tenantId: '', // 供应商id
      showDialog: false,
      active: '0',
      currentQuotation: {},
      roundsList: [],
      quotationDetail: [],
    };
  },
  methods: {
    handleClick () {
      this.currentQuotation = null;
      this.currentQuotation = this.roundsList[this.active * 1];
    },
    async queryHistoryQuotePriceList () {
      this.roundsList = [];
      const { body } = await historyQuotePriceList({
        findNewestFlag: false, // 是否查询最新的报价信息
        inquirePriceId: this.inquirePriceId,
        tenantId: this.tenantId,
        orderBy: [
          {
            orderByProperty: 'createTime',
            orderByType: 'ASC',
          },
        ],
      });

      if (body?.length) {
        for (let i = 0; i < body.length; i++) {
          this.roundsList.push({
            label: `报价轮次${i + 1}`,
            value: i + '',
            quotationDetail: body[i],
          });
        }
      }
      this.currentQuotation = this.roundsList[this.active * 1];
    },
  },
};
</script>
<style lang="scss" scoped>
.warning-tip {
  color: #E6A23C;
  padding-bottom: 15px;
}
.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
}
</style>
